/* eslint-disable quotes */
/* eslint-disable max-len */
export const langFile = {
  common: {
    close: 'Fermer',
    day: 'jour',
    euro: '€',
    included: 'Inclus',
    noResults: 'Aucun résultat',
    standardError:
      'Nous sommes désolés, une erreur inattendue est survenue. Veuillez réessayer plus tard ou contacter le service client.',
    vatIncluded: 'TVA COMPRISE',
    terminalIn: 'Terminal d\'entrée:',
    terminalOut: 'Terminal de sortie:',
    new: 'Nouveau',
  },
  confirmationStep: {
    return: 'Retour',
    psd2Title: "Activez votre carte pour pouvoir l'utiliser",
    psd2Body:
      "Votre banque vous demande de valider la carte ****{{cardNumber}} afin de l'utiliser lors de votre départ. Vous ne devez le faire qu'une seule fois et vous pouvez l'utiliser dans tous vos séjours chez nous.",
    psd2Button: 'Valider la carte',

    instagramTitle: 'Suis nous sur instagram',
    instagramBody:
      "Les meilleurs contenus sur aparca&go et tout ce que vous devez savoir sur votre voyage. Profitez également d'offres exclusives pour les abonnés !",
    instagramButton: 'Suivez @aparcandgo_es',
    checkCarsevices: 'Voir Car Service',
    willSendEmail:
      "Vous recevrez un email avec toutes les instructions d'arrivée et de retour.",
    isFastlane: 'Vous avez activé la voie rapide!',
    addServicesQuestion:
      'Vous souhaitez ajouter des services à votre réservation ?',
    addServicesText2: "Vous êtes toujours à l'heure.",
    addServicesClick: 'Cliquez ici!',
    reservationNumber: 'Numéro de réservation',
    additionalInfo: 'Informations supplémentaires',
    addServices: 'Ajouter des services',
    addServicesBody:
      'Il est encore temps de profiter de votre voyage et de réaliser la mise au point de votre véhicule.',
    agencyReservation:
      'Vous pouvez vérifier la réservation dans votre espace Agence.',

    appleWallet: 'Apple Wallet',
    cancelReservation: 'Annuler la réservation',
    carServiceInstructions: 'Instructions',
    checkReservation: 'Accéder à la réservation',
    validateChallengeText:
      'Vous pouvez accélérer le départ en validant votre carte.',
    validateChallengeButton: 'Valider maintenant',
    confirmationEmailSended: 'Nous vous envoyons un e-mail de confirmation',
    fastLaneWashWarning:
      '<b>Vous avez réservé un lavage de voiture.</b> Entrez vous au parking à la billetterie afin que notre personnel puisse vous indiquer la zone où vous devez garer et laisser les clés de votre véhicule.',
    covidTitle: 'Mesures Covid-19',
    covidBody:
      'Nous suivons toutes les mesures de sécurité afin que vous voyagiez l’esprit tranquille.',
    covidLink: '/fr/info-covid-19',
    downloadApp: 'Téléchargez notre application',
    downloadAppText:
      'Gérez votre réservation rapidement grâce à l’application aparca&go',
    downloadReservation: 'Télécharger la réservation',
    editReservation: 'Modifier la réservation',
    fastLaneBody:
      'Entrez et sortez de notre parking par la voie rapide grâce au code-barre que vous recevrez avant votre entrée.',
    fastLaneTitle: 'Vous pouvez aller encore plus vite !',
    fastLaneLink: '/fr/services/parking/voie-rapide',
    gracePeriodTitle: 'Avis sur le prix de votre réservation',
    gracePeriodBody:
      "N'oubliez pas que vous avez jusqu'à {{hours}}h de {{day}} pour récupérer votre véhicule sans aucun modification du prix de votre réservation.  Bon voyage! (<a title='+info tarifs' href='https://www.aparcandgo.com/fr/aviso-legal'>+info tarifs</a>)",
    ifNotRegistered:
      'Vous réservez sans avoir de compte ? Vous perdez de nombreux jours de parking gratuits. <b (click)="registerInConfirmation()"><u>Inscrivez-vous maintenant</u></b> et commencez à cumuler des euros grâce à aparca&go.',
    ifSporadicWithRegisteredEmail:
      'Avec cette réservation, vous pouvez accumuler des euros {{newPoints}}. <br> Liez votre réservation à votre compte client pour continuer à cumuler des euros et profiter de <a><u>votre espace en ligne.</u><a>',
    linkReservationCTA: 'Liez votre réservation',
    ifRegisteredPoints:
      'Avec cette réservation vous cumulerez {{newPoints}} euros',
    ifRegisteredPointsUser: ' sur votre solde actuel de {{userPoints}}.',
    instructions: 'Instructions',
    itv: 'ITV',
    maintenance: 'Entretien',
    manageReservation: 'Gérez votre réservation',
    moreInfo: 'Plus d’informations',
    others: 'Autres',
    paymentBody: 'Réglez cette réservation directement au parking.',
    paymentBodyExpress:
      'Vous pouvez payer comptant, par carte ou en utilisant notre application.',
    paymentTitleExpress:
      'Payer votre séjour dans notre parking au bureau de billets avant de partir.',
    paymentBodyPremium:
      'Vous pouvez payer par carte de crédit ou en utilisant notre application.',
    paymentTitlePremium:
      'Payer votre service lors de la cueillette de votre voiture.',
    paymentTitleUrban:
      'Payer votre séjour au {{urbanParkingName}} lors de la remise des clés de votre véhicule au box-office avant de quitter le parking.',
    paymentTitle:
      'Le paiement sera réalisé au parking (Express et gares) ou lors de la sortie pour le service Premium.',
    reviews: 'Révisions',
    thanks: 'Merci d’avoir réservé !',
    updated: 'Votre réservation a été mise à jour!',
    wash: 'Nettoyages',
    keysNeededReminder:
      "N'oubliez pas que la réservation nécessite de laisser la clé au guixet.",
    CTAForm2Title: 'Gagnez temps et vos efforts!',
    CTAForm2Body:
      "Ajoutez des services à votre réservation et profitez-en pour préparer votre voiture: lavage, faire le plein ou recharger, gonflage des pneus, changement des filtres et des huiles, passer l'ITV, etc... ou encore faire contrôler officiellement votre voiture.",
    CTAForm2BodyShort:
      'Ajoutez des services à votre réservation et profitez-en pour préparer votre voiture.',
    CTAForm2Click: 'Ajouter des services',
  },
  errorTailor: {
    email: 'E-mail non valide',
    maxLength: 'Vous ne devez pas dépasser {{requiredLength}}',
    minLength: 'Vous devez saisir {{requiredLength}} caractères ou plus',
    required: 'Champs obligatoire',
    requiredDni:
      "Document d’identification non valide. Assurez-vous que vous ajoutez un numéro de carte d'identité sans espaces, des tirets ou des points si votre nom commercial est un nom et prénom (personne) Ex: 11222333X. Assurez-vous que vous ajoutez une NIF entreprise sans espaces, des tirets ou des points si votre nom commercial est une société (juridique) Ex: B11222333",
    vatErrorFormatVies:
      ".Assurez-vous que si vous êtes hors d'Espagne et dans la CEE, ajoutez le numéro de TVA sans espaces, traits d'union ou points. Ex: PT111222333",
    requiredEmail: 'Nous vous enverrons votre confirmation à cette adresse.',
    requiredPhone: 'Nous vous contacterons si besoin',
    requiredSignPlate: 'Véhicule que vous allez garer',
    invalidNameDni: 'Le NIF saisi est un DNI, saisissez le nom et le prénom.',
    invalidNameNie: 'Le NIF saisi est un NIE, saisissez le nom et le prénom.',
  },
  homeModule: {
    homeForm: {
      email: 'E-mail',
      name: 'Prénom',
      needInvoice: 'J’ai besoin d’une facture',
      phone: 'Téléphone',
      signPlate: 'Numéro d’immatriculation',
      surname: 'Nom de famille',
      title: 'Détails de la réservation',
      travelForWork: 'Voyage d’affaires',
    },
  },
  notFoundPage: {
    message: 'Page introuvable',
  },
  navTab: {
    availableServices: 'Services disponibles',
    confirmation: 'Confirmation',
    five: '5',
    four: '4',
    howToPark: 'Service souhaité',
    one: '1',
    summary: 'Résumé',
    three: '3',
    travelerData: 'Informations sur le voyageur',
    two: '2',
    whereAndWhen: 'Lieu et date',
  },
  productsStep: {
    bkgAenaDialog: {
      text1:
        'La remise économique par rapport au parking officiel est calculée sur la base du tarif standard sans réservation.',
      text2:
        'Bien que nous surveillons ces prix en permanence, ces tarifs peuvent changer à tout moment. En cas de doute concernant le prix ou la remise affichée, n’hésitez pas à <a href="/es/contacto-telefono-email">nous contacter</a>, et nous répondrons à vos questions.',
      title: 'Comparateur de prix',
    },
    bkgProductCard: {
      aena: 'AENA',
      badDatesBody: "Pour bénéficier de ce service, choisissez d'autres dates.",
      badDatesTitle: 'Non disponible pour ces dates!',
      freeCancellation: 'Annulation gratuite',
      minutes: 'min.',
      moreInfo: 'Plus d’informations +',
      payTheParking: 'Paiement au parking',
      saving: 'Économies',
      select: 'Choisir',
      highDemandMessage:
        'Il y a une forte demande pour les dates que vous recherchez!',
      almostOutMessage:
        'Il reste très peu de places pour les dates que vous recherchez!',
      outOfStockMessage: 'Dernières places disponibles!',
      allTypePlacesOutMessage:
        "Non disponible pour ces dates! <br> <div>Pour bénéficier de ce service, choisissez d'autres dates.<div>",
    },
    bkgTripInfoCruiserName: {
      cruiserName: 'Numéro de vol',
      info:
        'Afin que nous puissions vous récupérer, veuillez nous indiquer le numéro du vol.',
      others: 'Autres',
    },
    bkgTripInfoDialog: {
      aboutYourTravel: 'Détails de la réservation',
      continue: 'Continuer',
      alert:
        'Du {{startDay}} juillet au {{endDay}} septembre, les véhicules de plus de 5,5 mètres ne peuvent pas accéder au parking',
    },
    bkgTripInfoExtras: {
      add: 'Ajouter +',
      added: 'Inclus',
      externalPlace: 'Place extérieure',
      improvePlace: 'Choisissez votre type de place de parking',
      highDemandMessage:
        'Il y a une forte demande pour les dates que vous recherchez!',
      almostOutMessage:
        'Il reste très peu de places pour les dates que vous recherchez !',
      outOfStockMessage: 'Épuisé',
      busClaim: "Vous vous garerez just à côté de l'arrêt de bus!",
    },
    bkgTripInfoPassengers: {
      passengersIn: 'Passagers à l’aller',
      passengersOut: 'Passagers au retour',
      passengersTooltip:
        'Nous devons connaître le nombre de passagers afin de pouvoir planifier le flux de passagers et vous offrir un meilleur service. Il n’y a pas de supplément par passager supplémentaire.',
      passengersTransfer: 'Combien de passagers faut-il transporter ?',
    },
    bkgTripInfoReturnFlight: {
      addReturnFlight:
        'Afin de pouvoir vous récupérer, veuillez nous indiquer le numéro de votre vol de retour.',
      returnFlight: 'IB1234',
    },
    bkgProductsPage: {
      selectDeliverCar: 'Choisissez comment vous garer',
      highDemandMessage:
        'Il y a une forte demande pour les dates que vous recherchez!',
      almostOutMessage:
        'Il reste très peu de places pour les dates que vous recherchez!',
      outOfStockMessage:
        "Il n'y a pas de disponibilité dans le parking pour les dates sélectionnées. Essayez de réserver pour une autre date.",
    },
  },
  sharedModule: {
    bkgSummaryVouchers: {
      title: "Utilise tes coupons!",
      discount_percent: "{{value}}% de réduction",
      discount_euro: "{{value}}€ de réduction",
      expires_on: "Expire le  <br>  {{date}}",
    },
    bkgVoucherBanner: {
      title_singular: "Vous avez 1 coupons disponible !",
      title_plural: "Vous avez {{count}} coupons disponibles !",
      body: "Utilise tes coupons!"
    },
    bkgCookiesAdvice: {
      accept: 'J’ai compris',
      reject: 'Rejeter',
      textHtml:
        'Ce site Web utilise des cookies internes et tiers pour effectuer un travail d\'analyse et obtenir des statistiques sur l\'utilisation du site Web par les utilisateurs. Vous pouvez configurer les cookies établis à tout moment et obtenir plus d\'informations à ce sujet dans la <a href="/fr/politique-de-cookies" title="">Politique de cookies</a>.',
    },
    bkgCustomTiresService: {
      added: 'Service ajouté avec succès.',
      title: 'Changement de pneus',
      body:
        "Profitez du fait que votre voiture est garée pour changer les pneus. Nous vous ferons parvenir un devis afin que vous l'acceptiez avant d'arriver au parking.",
    },
    bkgCustomServices: {
      added: 'Service ajouté avec succès.',
      title: 'Pouvez-vous trouver pas le service dont vous avez besoin?',
      body1: "C'est OK! Nous pouvons vous aider de toute façon.",
      body2:
        'Demandez-nous ce que vous avez besoin et nous ferons de notre mieux pour vous fournir une solution sur mesure.',
      notes: 'Prie les services dont vous avez besoin',
      terms:
        'En envoyant cette demande, vous acceptez les conditions de service de aparca&go. Nous vous informons que, aparca&go S.L. comme responsable du dossier, vous traitez les données dans le seul but de gérer la requête.',
    },
    bkgHeader: {
      account: 'Votre compte',
      greeting: 'Bonjour',
      login: 'Connexion',
      logout: 'Fermer la session',
      reservation: 'Vos réservations',
      businessMode: "Passer au profil de l'entreprise",
      individualMode: 'Passer au profil Individuel',
      signUp: 'Inscription',
    },
    bkgFeedbackDialog: {
      profileTitle: 'Profil ajouté avec succès',
      profileBody:
        'Vous pouvez à présent utiliser ce profil de facturation : {{profile}}',
      registerTitle: 'Inscription réussie',
      registerBody:
        'Nous vous avons envoyé un e-mail à l’adresse {{email}} afin que vous puissiez la confirmer.',
      servicesTitle: 'Service ajouté avec succès',
      servicesBody:
        'Vous pouvez continuer à ajouter des services à votre réservation ou cliquer sur le bouton Continuer pour la finaliser.',
      customServicesTitle: 'Service ajouté',
      customTiresServiceTitle: 'Service de changement de pneus ajouté!',
      customServicesBody:
        'Terminez votre réservation et nous communiquerons avec vous pour vous informer de la disponibilité et le coût du service que vous avez demandé.',
      vehicleTitle: 'Véhicule ajouté',
      vehicleTitleEdit: 'Véhicule modifié',
      vehicleBody:
        'Nous avons ajouté le véhicule dont l’immatriculation est {{plate}} - {{model}} à votre profil',
      vehicleDangerTitle: 'Véhicule non trouvé',
      vehicleDangerBody:
        'Veuillez sélectionner la marque et le modèle manuellement',
    },
    bkgFooter: {
      privacyLink: '/fr/politique-confidentialite',
      legalLink: '/fr/juridique-des-rapports',
      siteMapLink: '/fr/mapa-web',
      privacy: 'Privacidad',
      legal: 'Aviso legal',
      siteMap: 'Mapa del sitio',
      copyright: '© 2024 aparca&go S.L. Tous droits réservés.',
    },
    bkgHourPicker: {
      titleStart: 'À quelle heure voulez-vous laisser le véhicule ?',
      titleEnd: 'À quelle heure voulez-vous laisser le véhicule ?',
      info:
        '<p>Notre navette (réservation Express) vous emmènera à la porte du terminal en 5 minutes, mais nous vous recommandons tout de même d’arriver suffisamment en avance pour vous garer tranquillement.</p> <p>Si vous préférez nous laisser votre véhicule directement au terminal (réservation Premium), sélectionnez l’heure exacte à laquelle vous prévoyez d’arriver à l’aéroport. Nous vous attendrons !.</p>',
      infoShip:
        "<p>Choisissez votre heure d'enregistrement : 8h00, 9h15, 10h30, 12h30 ou 12h30 . Une fois garé, vous aurez 30 minutes pour prendre notre minibus gratuit qui vous conduira directement au parking du Port Cruise Terminal.</p>",
    },

    bkgInfoSectionDialog: {
      addToMyBooking: 'Ajouter service',
      checkControls: 'Vérification de {{controlsLength}} points de contrôle',
      removeFromMyBooking: 'Supprimer de ma réservation',
      select: 'Sélectionner',
      calculatePrice: 'Calculer le prix',
      price: 'Prix',
      vat: 'VAT (21%)',
      totalPrice: 'TOTAL CAR SERVICE',
    },
    bkgAlternativeOfferDialog: {
      title: "Ce produit n'est pas disponible",
      booking: 'Confirmer le changement',
      changesDatesOrProduct: 'Je veux changements',
      infoTooltip: '{{description}}',
      newPrice: 'Nouveau prix: ',
    },
    bkgInitialBookingDataDialog: {
      anotherTerminal: 'J’arrive à un autre terminal',
      bookingBtn: 'Réserver',
      dateAndTime: 'Date et heure',
      entrance: 'Entrée',
      exit: 'Sortie',
      where: 'Lieu',
      parking: 'Parking',
      selectParking: 'Sélectionner parking',
      title: 'Sélectionnez parking',
      dates: 'Actualiser la réservation',
      datesBtn: 'Continuer',
      deliverCar: 'Comment voulez-vous nous laisser votre véhicule ?',
      pickup: 'Où devons-nous vous emmener ?',
      welcomeTitle: 'Tout ce dont votre voiture a besoin pendant que vous voyagez',
      welcomeBody:
        'Réservez votre place de parking, ajoutez les services d\'atelier dont vous avez besoin et garez-vous rapidement, confortablement et en toute sécurité.',
    },
    bkgLoginDialog: {
      accountMessage: 'Vous n’avez pas de compte aparca&go ?',
      bodyTitle: 'Connectez-vous à votre compte',
      continueRegistration: 'Continuer sans m’inscrire',
      email: 'E-mail',
      facebookBtn: 'Facebook',
      forgetPassword: 'Récupérer mon mot de passe',
      googleBtn: 'Google',
      appleBtn: 'Apple',
      loginBtn: 'Connexion',
      password: 'Mot de passe',
      signUpFree: 'Inscription gratuite',
      title: 'Réservation encore plus rapide',
      individualCustomer: 'Particuliers',
      agencies: 'Agences',
      agencyTitle: "Connectez-vous à votre compte d'agence",
      alias: "Nom d'utilisateur",
    },
    bkgRecoveryPassDialog: {
      title: 'Réinitialiser mon mot de passe',
      body:
        'Saisissez l’adresse e-mail associée à votre compte et nous vous enverrons un lien de réinitialisation de mot de passe',
      send: 'Envoyer le lien',
      checkMail: 'Vérifiez votre e-mail',
      accept: 'D’accord',
      mailSended:
        'Nous vous avons envoyé un e-mail à l’adresse {{email}} afin que vous puissiez réinitialiser votre mot de passe.',
    },
    bkgSignUpDialog: {
      access: 'Connexion',
      bodyTitle:
        'Inscrivez-vous pour réserver encore plus rapidement et cumuler des euros que vous pourrez échanger contre des réductions.',
      cancel: 'Annuler',
      promoEmails:
        "J'accepte de recevoir les actualités, promotions et réductions d'aparca&go",
      newsletterEmails: "J'accepte de m'inscrire à la newsletter",
      continueBtn: 'Continuer sans m’inscrire',
      createError:
        'Une erreur s’est produite ! Vérifiez les informations et réessayez.',
      email: 'E-mail',
      haveAccount: 'Vous avez déjà un compte ?',
      name: 'Prénom',
      password: 'Mot de passe',
      privacyPolicy:
        'J’ai lu et compris la <a>Politique de confidentialité</a>',
      signUpFree: 'Inscription gratuite',
      signUpWithFb: 'Facebook',
      signUpWithApple: 'Apple',
      signUpWithGoogle: 'Google',
      surname: 'Nom de famille',
      title: 'Inscription gratuite',
    },
    bkgSummary: {
      acceptPromos:
        "J'accepte de recevoir les actualités, promotions et réductions d'aparca&go.",
      acceptNewsletter: "J'accepte de m'inscrire à la newsletter.",
      acceptTerms:
        'J’accepte la <a href="/es/politica-privacidad" target="_blank" title="Política de privacidad"><strong>Politique de confidentialité</strong></a> et les <a href="/es/aviso-legal" title="Condiciones de uso aparca&go" target="_blank"><strong>conditions d’utilisation</strong></a>',
      book: 'Réserver',
      carInsuranceTerms:
        'Je certifie que le véhicule est couvert par l’assurance auto obligatoire et l’autorisation administrative de circulation correspondante.',
      carServiceTerms:
        'J’autorise aparca&go et ses garages partenaires à circuler avec mon véhicule durant le temps minimum nécessaire pour réaliser les services souscrits.',
      continue: 'Continuer',
      needServices:
        'Vous devez sélectionner au moins un service pour continuer',
      disabledTerms: 'Accepter les conditions de vente.',
      disabledBookingForm: 'Vérifier les détails de la réservation.',
      disabledBillingForm: 'Vérifier les données de facturation.',
      estimateAccept: '*En réservant, vous acceptez le devis',
      reservationNumber: 'Numéro de réservation',
      return: 'Retour',
      termsAccepted:
        'En réservant, vous acceptez les <a href="/es/politica-privacidad" target="_blank" title="Política de privacidad"><strong>termes</strong></a> et <a href="/es/aviso-legal" title="Condiciones de uso aparca&go" target="_blank"><strong>conditions d\'utilisation/strong></a> d\'aparca&go.',
    },
    bkgSummaryDiscounts: {
      availablePoints: 'Vos euros disponibles :',
      discount: 'Remise :',
      havePromoCode: 'Vous avez un code promo ?',
      insertCode: 'Saisissez votre code',
      pointsApplied: '¡{{points}} euros appliqués avec succès !',
      promoFailed: 'Code non valide',
      promoSuccess: 'Votre code promo a été appliqué !',
      redeem: 'Échanger',
      validate: 'Valider',
      wantUsePoints: 'Vous souhaitez utiliser vos euros?',
    },
    bkgSummaryLocation: {
      location: 'Emplacement du parking',
      premiumLocation: 'Point de livraison',
      locationDescription: 'Consultez l’emplacement du parking sur la carte.',
      openMap: 'Ouvrir la carte',
      parkingLocation: 'Emplacement du parking',
      howToGet: 'Comment s’y rendre',
    },
    bkgSummaryPrice: {
      carServiceDiscount: 'Remise Car Service',
      customService: 'Service personnalisé',
      customTiresService: 'Changement de pneus',
      free: 'Gratuit',
      freeCancellation: 'Annulation gratuite',
      payInParking: 'Payer au parking',
      place: 'Place',
      doubleSpace: 'Espace Double',
      points: 'Points aparca&go',
      price: 'Services et prix',
      promo: 'Promo',
      total: 'TOTAL',
      wash: 'Nettoyage',
      totalWithoutPromo: 'TOTAL SANS PROMO',
      removal: 'Transfert',
      taxesSentence2:
        "(*) Tarifs officiels selon le type d'émission du véhicule : 40,60 € essence, 45,59 € diesel, 54,98 € fourgon diesel industriel...)",
      taxesSentence3: "(*) Taux officiels selon le type d'émission du véhicule",
      carDiscountTitle: 'Réductions Promo Car Service',
      carDiscountBody:
        "Vous avez sélectionné des services d'une valeur de {{total}}€, vous bénéficiez donc d'une réduction de {{discount}}% sur le coût de votre stationnement.<br><br>Tableau des réductions sur le stationnement en ajoutant des services Car Service:<br><br>25% sur le stationnement à partir de 99€ chez Car Service<br>50% sur le stationnement à partir de 199€ chez Car Service<br>75% sur le stationnement à partir de 299€ chez Car Service<br>Parking gratuit jusqu'à 40€ à partir de 499€ chez Car Service!",
      carFerryBody:
        "Pour les réservations de services Car Service d'un montant inférieur à 200 €, nous ajoutons le coût du transfert du véhicule à l'atelier. Ajouter plus de services pour éliminer le coût du transfert.",
    },
    bkgSummaryReservation: {
      checkIn: 'Entrée :',
      checkOut: 'Sortie :',
      checkInPremium: 'Entrée :',
      checkOutPremium: 'Sortie:',
      diffTimeZone: "Spain's Timezone",
      data: 'Informations',
      email: 'E-mail :',
      flightNumber: 'Num. vol retour :',
      modify: 'Modifier',
      name: 'Nom :',
      plate: 'Numéro d’immatriculation :',
      terminal: 'Terminal :',
      outTerminal: 'Terminal de retour:',
      yourReservation: 'Détails de la réservation',
      billingProfile: 'Profil de facturation:',
    },
    bkgSummaryServices: {
      detail: 'Détails',
      modify: 'Modifier',
      remove: 'Supprimer',
      services: 'Services',
    },
    bkgSummaryVehicle: {
      modify: 'Modifier',
      yourVehicle: 'Votre véhicule',
      edit: 'Éditer',
    },
    bkgVehicleDialog: {
      addVehicle: 'Ajouter véhicule',
      editVehicle: 'Modifier le véhicule',
      selectVehicleTitle: 'Sélectionner véhicule',
    },
    bkgVehicleDialogSelectClientCar: {
      addNewVehicle: 'Ajoutez un nouveau véhicule',
      agree: 'Accepter',
      selectVehicle: 'Sélectionner véhicule',
      selectVehicleSubtitle: 'Choisissez votre véhicule',
    },
    bkgVehicleDialogCompleteCarDataForm: {
      agree: 'Accepter',
      body: 'Carrosserie',
      completeVehicleInfo:
        'Nous avons besoin de plus d’informations sur votre véhicule afin de vous indiquer le prix exact de votre service',
      kilometers: 'Kilomètres',
      motor: 'Moteur',
      selectBody: 'Sélectionner carrosserie',
      selectMotor: 'Sélectionner moteur',
    },
    bkgVehicleDialogLicensePlate: {
      agree: 'Accepter',
      forgottenCarLicensePlate:
        'Je ne me souviens plus du numéro d’immatriculation',
      insertCarLicensePlate:
        'Quel est le numéro d’immatriculation de votre véhicule ?',
      placeholderPlate: '0000 ABC',
    },
    bkgVehicleDialogUmcSelectors: {
      addMakeModelSubtitle: 'Utilisez la marque ou le modèle du véhicule',
      agree: 'Accepter',
      make: 'Marque :',
      model: 'Modèle :',
      notFoundCarOption: 'Je ne trouve pas mon véhicule',
      propulsion: 'Moteur :',
      selectMake: 'Sélectionner marque',
      selectModel: 'Sélectionner modèle',
      selectPropulsion: 'Sélectionner moteur',
      fromToCurrent: "à partir de l'année {{ from }}",
      fromToYear: 'entre {{ from }} et {{to}}',
      year: 'Année de fabrication',
    },
    bkgVehicleDialogNotFoundForm: {
      email: 'E-mail',
      color: 'Couleur',
      make: 'Marque',
      model: 'Modèle',
      send: 'Envoyer',
      text:
        'Indiquez-nous la marque et le modèle de votre véhicule et nous vous contacterons rapidement avec le devis.',
    },
    bkgVehicleWarningDialog: {
      title: 'Attention !',
      text1:
        'Cette action supprimera le véhicule sélectionné ainsi que les services mécaniques ajoutés précédemment.',
      text2: 'Changer de véhicule ?',
      textModifyKm:
        'A la fin de cette action pour les services mécaniques précédemment ajoutés seront supprimés.',
      textModifyWorkshop:
        'A la fin de cette action pour les services mécaniques précédemment ajoutés seront supprimés.',
      accept: 'Accepter',
      cancel: 'Annuler',
    },
    bkgLinkReservationDialog: {
      title: 'Matière',
      loginText: 'Connectez-vous pour lier la réservation',
      linkReservationText:
        'Votre compte a plusieurs configurations. Confirmez celui que vous préférez utiliser dans votre réservation.',
      linkReservationTextWithoutConfigurations:
        'Confirmez que vous souhaitez enregistrer cette réservation sur votre compte',
      forgetPassword: 'Récupérer le mot de passe',
      password: 'Mot de passe',
      vehicle: 'Véhicule',
      profile: 'Données de facturation',
      saveBtn: 'Enregistrer',
      importBtn: 'Importer',
      login: 'Connexion',
      profileCheckbox: 'Ne pas lier les données de facturation',
      importVehicle: 'Lier le véhicule actuel',
    },
    bkgChangeUserModeDialog: {
      titleChangeBusiness: "Voulez-vous passer à votre profil d'entreprise?",
      titleChangeParticular: 'Voulez-vous passer à votre profil particulier?',
      bodyChangeBusiness:
        "Vous réservez en tant qu'utilisateur particulier. Si vous souhaitez effectuer une réservation d'entreprise avec une facture, cliquez sur 'changer en profil d'entreprise'. ",
      bodyChangeParticular:
        "Vous réservez en tant qu'utilisateur professionnel. Si vous souhaitez effectuer une réservation particulier sans facture, cliquez sur 'changer en profil particulier'.",
      btnChangeBusiness: "Modifier le profil de l'entreprise",
      btnChangeParticular: 'Passer à un profil particulier',
      btnStayAsParticular:
        "Continuer la réservation en tant qu'utilisateur particulier",
      btnStayAsBusiness:
        "Continuer la réservation en tant qu'utilisateur professionnel",
    },
  },
  servicesStep: {
    title: 'Profitez-en pour faire peaufiner votre voiture',
    bkgExtraServices: {
      add: 'add	Ajouter +',
      availableServicesFrom:
        '{{ extrasLength }} programmes disponibles auprès de {{ cheaperServiceUnitaryPrice }}€',
      desinfection: 'Nettoyages avec désinfection',
      remove: 'Supprimer -',
      washes: 'Nettoyage et désinfection',
      blockWashes: 'Service bloqué par votre entreprise',
    },
    bkgCarServices: {
      add: 'Ajouter +',
      calculatePrice: 'Calculer le prix',
      freeReservation: 'Votre réservation peut vous être offerte !',
      notAvailable: 'Actuellement indisponible',
      remove: 'Supprimer -',
      detail: 'Voir détail +',
      workshopText:
        'Choisissez si vous souhaitez contracter un service avec un atelier mécanique aparca&go ou avec un revendeur officiel.',
      agoWorkshop: 'aparca&go ateliers mécaniques',
      officialWorkshop: 'Revendeur officiel.',
      needFees: '+ taxes (impôts)',
      availabilityHighDemand: 'Peu de places disponibles',
      availabilityAlmostOut: 'Presque épuisé',
      availabilityOutOfStock: 'Épuisé',
    },
    bkgCarServicesB: {
      title: 'Car Service',
      minPriceWarranty: 'Preu mínim garantitzat',
    },
    bkgAdditionalCarServices: {
      title: 'Serveis suplementaris',
    },
  },
  travelerStep: {
    billingForm: {
      addProfile: 'Ajouter profil',
      companyAddress: 'Adresse',
      companyCity: 'Ville',
      companyEmail: 'E-mail de facturation',
      companyName: 'Nom de l’entreprise/nom et prénom',
      companyState: 'Province',
      companyVat: 'CIF/NIF',
      companyZip: 'Code postal',
      companyCountry: 'Pays',
      createProfile: 'Créer un profil de facturation',
      editProfile: 'Modifier le profil',
      editProfileTitle: 'Modifier le profil de facturation',
      needInvoiceData:
        'En vertu des dispositions légales, les prestations des garagistes s’accompagnent systématiquement d’une facture.',
      newProfileBody:
        'Créez un profil de facturation afin de sauvegarder vos coordonnées et ne plus avoir à les saisir pour les prochaines réservations',
      newProfileTitle: 'Nouveau profil de facturation',
      profile: 'Profil',
      title: 'Informations de facturation',
      preventEditCorporateProfile: 'Accédez à votre espace personnel pour modifier un profil entreprise',
    },
    invoiceProfileDialog: {
      accept: 'Accepter',
      companyAddress: 'Adresse',
      companyCity: 'Ville',
      companyEmail: 'E-mail de facturation',
      companyName: 'Nom de l’entreprise/nom et prénom',
      companyState: 'Province',
      companyVat: 'CIF/NIF',
      companyZip: 'Code postal',
      companyCountry: 'Pays',
      invoicingMethod: 'Méthode de facturation',
      monthly: 'Mensuelle',
      saveAsDefaultProfile: 'Sauvegarder comme profil par défaut',
      service: 'Par service',
      nifError: 'Le NIF saisi est un DNI, saisissez le nom et le prénom.',
      nieError: 'Le NIF saisi est un NIE, saisissez le nom et le prénom.',
    },
    reservationForm: {
      addVehicle: 'Ajouter véhicule',
      editVehicle: 'Modifier véhicule',
      email: 'E-mail',
      name: 'Prénom',
      needInvoice: 'J’ai besoin d’une facture',
      optional: '(Optionnel)',
      phone: 'Téléphone',
      record: 'Numéro Fichier',
      recordCompany: 'Référence de voyage',
      signPlate: 'Numéro d’immatriculation',
      surname: 'Nom de famille',
      title: 'Détails de la réservation',
      travelForWork: 'Voyage d’affaires',
      travelForWorkTooltip:
        "Vous voyagez pour le travail ? Passez à votre profil d'entreprise.",
      paymethod: 'Mode de paiement',
      paymethodComment:
        "Nous ne vous facturons pas maintenant, c'est pour accélérer votre départ.",
      vehicle: 'Véhicule',
      notes: 'Commentaire sur votre réservation (facultatif)',
      indicateAtExit: 'Indiquer à la sortie.',
      employees: 'Employés',
      employeesTooltip:
        'Sélectionnez le travailleur pour qui vous réservez le parking',
      yourData: 'Vos coordonnées',
      modify: 'Modifier',
    },
  },

};
